import React from 'react';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';

const FAQPage = () => {
  return (
    <div style={{ backgroundColor: '#1e1e1e', color: '#fff', minHeight: '100vh' }}>
      {/* Navbar */}
      <Navbar />

      {/* Main content */}
      <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '20px' }}>Frequently Asked Questions</h1>

        <p style={{ fontSize: '1rem', marginBottom: '20px', lineHeight: '1.6' }}>
          Can't find what you're looking for? Message us for help or consider donating to support the server and its future improvements!
          <a href="/donate" style={{ color: '#4e9eff', textDecoration: 'none' }}> Donate here</a>.
        </p>

        {/* FAQ Section */}
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', borderBottom: '2px solid #333', paddingBottom: '10px' }}>
            Common Questions About the Server
          </h2>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: How do I join the server?</strong><br />
              A: You can join by entering our server address after logging into Minecraft. Make sure you’ve registered an account with us first!
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: Why do we use Aternos for hosting?</strong><br />
              A: We currently use Aternos due to budget constraints. It allows us to run the server for free, but your donations can help us upgrade to better hosting with improved performance and uptime.
              <a href="/donate" style={{ color: '#4e9eff', textDecoration: 'none' }}> Consider donating</a>.
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: How can I donate to support the server?</strong><br />
              A: You can contribute directly through our donation page. Your support helps us scale the server and introduce new features.
              <a href="/donate" style={{ color: '#4e9eff', textDecoration: 'none' }}> Visit the donation page</a>.
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: How can I invite friends to the server?</strong><br />
              A: Simply share our server address with your friends and ensure they’ve registered an account. We’re always excited to welcome new players!
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: What mods or plugins are installed on the server?</strong><br />
              A: We have various plugins to enhance gameplay, such as economy systems, custom items, and mini-games like BedWars and SkyBlock. We regularly update the server with new content to keep things fresh.
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: Can I apply for a staff position on the server?</strong><br />
              A: Yes! We’re currently looking for passionate individuals to join our team as Moderators, Administrators, and Developers. Please note that we are unable to offer paid positions at this time due to limited resources, but it's a great opportunity to be part of our growing community.
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: How do I report a player?</strong><br />
              A: You can report any player issues via our Discord server or by using the in-game /report command. Our moderators will handle the situation as soon as possible.
            </p>
          </div>

          {/* Revised Server Full Question */}
          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: What happens if the server is full?</strong><br />
              A: If the server is at full capacity, you will need to wait until space becomes available. If you feel the wait is excessive, please report the issue to our moderators on Discord. They may help by kicking inactive (AFK) players to free up space. 
              If you'd like to support us and reduce these issues, please consider donating so we can expand our server capacity.
              <a href="/donate" style={{ color: '#4e9eff', textDecoration: 'none' }}> Learn more here</a>.
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              <strong>Q: How can I suggest new features for the server?</strong><br />
              A: We love hearing from our community! You can submit your ideas via our Discord server or through the suggestion form on our website. We’re always open to improving the server based on player feedback.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default FAQPage;
